import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { AppConsts } from '../../../shared/AppConsts';
import { GrafanaConfiguration } from './grafana-configuration.model';

export function appInitializeFaro(grafanaConfiguration: GrafanaConfiguration): void {
  const isEnabled: boolean = grafanaConfiguration.isEnabled;
  const allowUrls = [
      new RegExp(grafanaConfiguration.allowUrl + '/*'),
  ]
  
  if (!isEnabled) {
      return;
  }
  
  const versionNumber = AppConsts.WebAppGuiVersion;
  const environmentName = grafanaConfiguration.environmentName;
  const grafanaUrl = grafanaConfiguration.url;
  const appNameForGrafana = AppConsts.GrafanaApplicationName;

  initializeFaro({
      url: grafanaUrl,
      app: {
          name: appNameForGrafana,
          version: versionNumber,
          environment: environmentName,
      },
      instrumentations: [...getWebInstrumentations({ captureConsole: true, captureConsoleDisabledLevels: [] }),
          new TracingInstrumentation({
              instrumentationOptions: {
                  propagateTraceHeaderCorsUrls: allowUrls,
              },
          })
      ],
  });
}